
import Vue from 'vue';
import SkeletonLoader from '@root/common/components/base/loader/SkeletonLoader.vue';
import isMobileView from '@root/common/utils/isMobileView';

export default Vue.extend({
  components: {
    SkeletonLoader,
  },
  props: {
    renderBanner: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  computed: {
    isMobileView(): boolean {
      return isMobileView();
    },
  },
});
